package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.utils.AdManager
import com.klantenstop.web.utils.SiteGlobals
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

/**
 * Reusable AdSense slot wrapper.
 *
 * The actual ad request is delegated to [AdManager], which enforces consent and
 * non-personalized mode before any script interaction happens.
 */
@Composable
fun AdSlot(
    slotName: String,
    adUnitId: String,
    modifier: Modifier = Modifier,
    showLabel: Boolean = true,
    minHeightPx: Int = 120,
    adFormat: String = "auto",
    fullWidthResponsive: Boolean = true,
) {
    val hasConsent by AdManager.consentState.collectAsState()
    val containerId = "ks-ad-slot-$slotName"
    val isDevelopment = SiteGlobals.environment == "development"
    val hasConfiguredSlot = adUnitId.isNotBlank()

    if (!hasConfiguredSlot && isDevelopment) {
        Column(
            modifier = modifier
                .fillMaxWidth()
                .backgroundColor(MaterialColorVars.SurfaceContainerLowest.value())
                .border(1.px, LineStyle.Dashed, MaterialColorVars.OutlineVariant.value())
                .borderRadius(12.px)
                .padding(12.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(8.px)
        ) {
            SpanText(
                modifier = Modifier
                    .fontSize(12.px)
                    .color(MaterialColorVars.OnSurfaceVariant.value())
                    .textAlign(TextAlign.Center),
                text = "Advertentie placeholder"
            )
            SpanText(
                modifier = Modifier
                    .fontSize(12.px)
                    .color(MaterialColorVars.OnSurfaceVariant.value())
                    .textAlign(TextAlign.Center),
                text = "slot=$slotName"
            )
            Div(
                attrs = Modifier
                    .fillMaxWidth()
                    .minHeight(minHeightPx.px)
                    .margin(top = 4.px)
                    .toAttrs {
                        attr("aria-label", "Advertentie placeholder")
                    }
            )
        }
        return
    }

    if (!hasConfiguredSlot) return

    if (!hasConsent) {
        LaunchedEffect(slotName, adUnitId) {
            AdManager.mountAdSlot(
                containerId = containerId,
                slotName = slotName,
                adUnitId = adUnitId,
                adFormat = adFormat,
                fullWidthResponsive = fullWidthResponsive
            )
        }
        return
    }

    LaunchedEffect(hasConsent, slotName, adUnitId, adFormat, fullWidthResponsive) {
        AdManager.mountAdSlot(
            containerId = containerId,
            slotName = slotName,
            adUnitId = adUnitId,
            adFormat = adFormat,
            fullWidthResponsive = fullWidthResponsive
        )
    }

    Column(
        modifier = modifier
            .fillMaxWidth()
            .backgroundColor(MaterialColorVars.SurfaceContainerLowest.value())
            .border(1.px, LineStyle.Solid, MaterialColorVars.OutlineVariant.value())
            .borderRadius(12.px)
            .padding(12.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(8.px)
    ) {
        if (showLabel) {
            SpanText(
                modifier = Modifier
                    .fontSize(12.px)
                    .color(MaterialColorVars.OnSurfaceVariant.value())
                    .textAlign(TextAlign.Center),
                text = "Advertentie"
            )
        }

        Div(
            attrs = Modifier
                .fillMaxWidth()
                .minHeight(minHeightPx.px)
                .margin(top = 4.px)
                .toAttrs {
                    attr("id", containerId)
                    attr("aria-label", "Advertentieblok")
                }
        )
    }
}




